import React, { useMemo } from 'react';
import { InlineInputCardWrapper } from '@/features/editor/widgets/shared/ai-editing-layout/inputs/shared/shared';
import { SingleSelectInput } from '@/features/editor/widgets/shared/ai-editing-layout/inputs/shared/single-select-input';

export interface GenericJsCollectionsStrategyInputProps {
  value: string;
  onChange: (value: string) => void;
}

const STRATEGY_OPTIONS = [
  { value: `v`, label: `Most Visited` },
  { value: `o`, label: `Best Selling` },
];

export function GenericJsCollectionsStrategyInput({
  value,
  onChange,
}: GenericJsCollectionsStrategyInputProps) {
  const selectedOption = useMemo(
    () =>
      STRATEGY_OPTIONS.find((option) => option.value === value) ||
      STRATEGY_OPTIONS[0],
    [value],
  );

  return (
    <InlineInputCardWrapper>
      <span>Collections Strategy</span>
      <SingleSelectInput
        options={STRATEGY_OPTIONS}
        initialValue={selectedOption}
        onChange={(option) => onChange(option.value as string)}
      />
    </InlineInputCardWrapper>
  );
}
